export default "__VITE_ASSET__DtzP44Ie__"